<template>
  <div>
    <!-- 검색 -->
    <search-nav @handleSearch="handleSearch" class="mb-8">
      <search-nav-year-month label="연도" type="year" yearAfter="" v-model="search.연도" :use-all-year="false" />
      <search-nav-item-select
        label="월"
        v-model="search.분기"
        :list="[
          { value: 0, text: '전체'},
          { value: 1, text: '1월' },
          { value: 2, text: '2월' },
          { value: 3, text: '3월' },
          { value: 4, text: '4월' },
          { value: 5, text: '5월' },
          { value: 6, text: '6월' },
          { value: 7, text: '7월' },
          { value: 8, text: '8월' },
          { value: 9, text: '9월' },
          { value: 10, text: '10월' },
          { value: 11, text: '11월' },
          { value: 12, text: '12월' },
        ]"
      />
      <!--      <search-nav-item-select label="교육구분" v-model="search.교육구분" :list="diffData" />-->
      <!--      <search-nav-item-radio id="searchRadio1" label="구분" v-model="search.구분" :list="['사업장별', '부서별']" />-->
      <search-nav-item-field-select v-if="search.구분 === '사업장별'" label="학교명" v-model="search.학교명" />
      <search-nav-item-company v-else label="부서명" v-model="search.부서명" size="big" />
      <search-nav-item-keyword :viewLabel="true" label="ID(사번)" v-model="search.사번" />
    </search-nav>

    <!-- 총원 -->
    <table class="total mb-5">
      <colgroup>
        <col width="240" />
      </colgroup>
      <thead>
      <tr>
        <th>구분</th>
        <th>정기안전교육</th>
        <th>특별안전보건교육</th>
        <th>채용시 안전교육</th>
        <th>작업내용 변경시 안전교육</th>
        <th>안전보건총괄책임자 교육</th>
        <th>안전보건관리책임자 교육</th>
        <th>관리감독자 안전교육</th>
        <th>MSDS</th>
        <th>기타</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>현업근로자 기준 이수시간</td>
        <td>반기별 12시간 이상<br/>(월별 2시간 이상)</td>
        <td>16시간 이상 (최초4시간, 12시간은 3개월 이내 분할 실시), 단기 또는 간헐적 작업은 2시간 이상</td>
        <td>8시간 이상</td>
        <td>2시간 이상</td>
        <td>-</td>
        <td>-</td>
        <td>-</td>
        <td>-</td>
        <td>-</td>
      </tr>
      <tr>
        <td>
          <div class="flex items-center justify-center gap-1"><feather-icon icon="AlertCircleIcon" style="width: 16px; height: 16px" class="cursor-pointer" @click="showPopup = true" /> 이수자/총원</div>
        </td>
        <fragment v-if="!!summary.count">
          <td class="circle" :class="!!summary['정기안전교육'] && summary.count <= summary['정기안전교육'][6] && 'green'">{{ !!summary["정기안전교육"] ? summary["정기안전교육"][6] : 0 }}명 / {{ summary.count }}명</td>
          <td class="circle" :class="!!summary['특별안전보건교육'] && summary.count <= summary['특별안전보건교육'][16] && 'green'">{{ !!summary["특별안전보건교육"] ? summary["특별안전보건교육"][16] : 0 }}명 / {{ summary.count }}명</td>
          <td class="circle" :class="!!summary['채용시 안전교육'] && summary.count <= summary['채용시 안전교육'][8] && 'green'">{{ !!summary["채용시 안전교육"] ? summary["채용시 안전교육"][8] : 0 }}명 / {{ summary.count }}명</td>
          <td class="circle" :class="!!summary['작업내용 변경시 안전교육'] && summary.count <= summary['작업내용 변경시 안전교육'][2] && 'green'">
            {{ !!summary["작업내용 변경시 안전교육"] ? summary["작업내용 변경시 안전교육"][2] : 0 }}명 / {{ summary.count }}명
          </td>
        </fragment>
        <fragment v-else>
          <td>-</td>
          <td>-</td>
          <td>-</td>
          <td>-</td>
        </fragment>
        <td>-</td>
        <td>-</td>
        <td>-</td>
        <td>-</td>
        <td>-</td>
      </tr>
      </tbody>
    </table>

    <!-- 리스트 -->
    <CustomOptionSelector
      :options="[
        { value: 20, text: '20개씩 보기' },
        { value: 50, text: '50개씩 보기' },
        { value: 100, text: '100개씩 보기' },
      ]"
      v-model="perPage"
      class="mb-4"
    />
    <table class="list">
      <colgroup>
        <col width="60" />
      </colgroup>
      <thead>
      <tr>
        <th>No.</th>
        <th>학교명</th>
        <th>ID(사번)</th>
        <th>구분/직종</th>
        <th>정기안전교육</th>
        <th>특별안전보건교육</th>
        <th>채용시 안전교육</th>
        <th>작업내용 변경시 안전교육</th>
        <th>안전보건총괄책임자 교육</th>
        <th>안전보건관리책임자 교육</th>
        <th>관리감독자 안전교육</th>
        <th>MSDS</th>
        <th>기타</th>
      </tr>
      </thead>
      <tbody v-if="loading">
      <tr>
        <td colspan="13">
          <div class="w-full p-5 flex items-center justify-center" style="min-height: 100px;">
            <feather-icon icon="LoaderIcon" class="mr-2 rotate-icon" />
            데이터를 불러오는 중입니다.
          </div>
        </td>
      </tr>
      </tbody>
      <tbody v-else-if="list.length > 0">
      <fragment v-for="(item, _index) in currentPageList" :key="item.employee.id">
        <tr>
          <td>{{ (page - 1) * perPage + _index + 1 }}</td>
          <td>{{ item.field.field_name || '-' }}</td>
          <td>{{ item.employee.employee_id || '-' }}</td>
          <td>{{ getEmployeeType(item) }}</td>
          <td :class="교육_클래스('정기안전교육', item)">
            {{ findEducation("정기안전교육", item.educationHours).text }}
          </td>
          <td :class="교육_클래스('특별안전보건교육', item)">
            {{ findEducation("특별안전보건교육", item.educationHours).text }}
          </td>
          <td :class="교육_클래스('채용시 안전교육', item)">
            {{ findEducation("채용시 안전교육", item.educationHours).text }}
          </td>
          <td :class="교육_클래스('작업내용 변경시 안전교육', item)">
            {{ findEducation("작업내용 변경시 안전교육", item.educationHours).text }}
          </td>
          <td>{{ findEducation("안전보건총괄책임자 교육", item.educationHours).text || "-" }}</td>
          <td>{{ findEducation("안전보건관리책임자 교육", item.educationHours).text || "-" }}</td>
          <td>{{ findEducation("관리감독자 안전교육", item.educationHours).text || "-" }}</td>
          <td>{{ findEducation("MSDS", item.educationHours).text || "-" }}</td>
          <td>{{ findEducation("기타", item.educationHours).text || "-" }}</td>
        </tr>
      </fragment>
      </tbody>
      <tbody v-else>
      <tr>
        <td colspan="13">
          <div class="w-full p-5 flex items-center justify-center" style="min-height: 100px;">
            <feather-icon icon="AlertTriangleIcon" class="mr-2"/>
            표시할 데이터가 없습니다.
          </div>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="vs-con-table">
      <div class="con-pagination-table vs-table--pagination">
        <k-pagination :total="total" v-model="page" @change="handleChangePage"></k-pagination>
      </div>
    </div>

    <vs-popup title="교육 이수자/총원" :active.sync="showPopup" id="alertUserSelectPopup">
      <div style="font-weight: 500; font-size: 14px; line-height: 20px">
        1명의 종사자가 N개의 사업장에 참여하고 있으면, 각 사업장별로 1명씩 N명으로 카운트 <br />
        예) "홍길동" 이라는 종사자가 "A사업장"에서는 교육 시간을 충족하고, "B사업장"에서는 충족하지 않으면, <b>이수자/총원 = 1명/2명</b>
      </div>
      <div>
        <p style="font-weight: 500; font-size: 14px; line-height: 20px" class="mt-3 mb-1">참고</p>
        <div style="font-weight: 400; font-size: 14px; line-height: 20px; border: 1px solid #cdcdcd" class="p-2">
          ｢산업안전보건법」은 단위 사업장별로 그 업종, 규모 등에따라적용하므로 본사, 공장, 지점, 영업소, 출장소 등이 장소적으로분산되어 있는 경우에는 원칙적으로 각각 별개의 사업장으로 보아야함.
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import HttpRequest from "@/util/HttpRequest";
import DiffData from "@/views/boards/single-page/434/DiffData.js";

import SearchNav from "@/components/nav/SearchNav";
import SearchNavYearMonth from "@/components/nav/SearchNavYearMonth.vue";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import SearchNavItemRadio from "@/components/nav/SearchNavItemRadio";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import SearchNavItemCompany from "@/components/nav/SearchNavItemCompany.vue";
import SearchNavItemFieldSelect from "@/components/nav/SearchNavItemFieldSelect";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import KPagination from "@/components/kPagination/kPagination";

export default {
  components: {
    SearchNav,
    SearchNavYearMonth,
    SearchNavItemSelect,
    SearchNavItemRadio,
    SearchNavItemKeyword,
    SearchNavItemCompany,
    SearchNavItemFieldSelect,
    CustomOptionSelector,
    KPagination,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    diffData() {
      return DiffData;
    },
    total() {
      const _total = Math.ceil(this.list.length / this.perPage);
      return _total < 1 ? 1 : _total;
    },
    currentPageList() {
      return this.list.slice((this.page - 1) * this.perPage, this.page * this.perPage);
    }
  },
  data() {
    return {
      loading: false,
      showPopup: false,

      search: {
        연도: { year: new Date().getFullYear(), month: "" },
        분기: "",
        교육구분: "",
        구분: "사업장별",
        학교명: "",
        부서명: "",
        사번: "",
      },

      page: 1,
      perPage: 20,
      list: [],
      summary: {},
    };
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    async handleSearch() {
      if (!this.search.연도) {
        alert("연도를 선택해주세요.");
        return;
      }

      const params = {
        year: this.search.연도.year,
        month: this.search.분기 ? this.search.분기 : undefined,
        // quarter: this.search.분기,
        // education_type: this.search.교육구분,
        employee_number: this.search.사번,
      };

      if (this.search.구분 === "사업장별") params.field_id = this.search.학교명;
      else params.company_id = this.search.부서명;

      this.loading = true;
      await Promise.all([
        HttpRequest.get(`/api/v1/employee/${this.projectId}/education/aggregation`, { params })
          .then((response) => {
            this.page = 1;
            this.list = response;
          })
          .catch((/*ignore*/) => {
            this.list = [];
          }),

        HttpRequest.get(`/api/v1/employee/${this.projectId}/education/aggregation/summary`, { params })
          .then((response) => {
            const data = response.fieldEmployeeCount[0];
            this.summary = { count: data.employeeCount, ...data.education };
          })
          .catch((/*ignore*/) => {
            this.summary = {};
          }),
      ]);
      this.loading = false;
    },
    handleChangePage(page) {
      this.page = page;
    },
    findEducation(label, data) {
      const findLabel = data.find((item) => item.education_type === label);
      return findLabel ? { time: Math.floor(findLabel.total_education_hours), text: this.floatToTimeString(findLabel.total_education_hours) } : { time: 0, text: null };
    },
    floatToTimeString(floatNumber) {
      const hour = Math.floor(floatNumber);
      const minute = Math.round((floatNumber - hour) * 60);

      return `${hour.toString().padStart(2, "0")}시간 ${minute.toString().padStart(2, "0")}분`;
    },
    getEmployeeType(item) {
      // {{ item.employee.job_category }} / {{ item.employee.employment_type }}
      const employee = item.employee;
      if (employee.job_category && employee.employment_type) {
        return `${employee.job_category} / ${employee.employment_type}`;
      } else if (employee.job_category) {
        return employee.job_category;
      } else if (employee.employment_type) {
        return employee.employment_type;
      } else {
        return "-";
      }
    },
    /*
    <td :class="6 <= findEducation('정기안전교육', item.educationHours).time ? 'circle green' : 'circle'">
              {{ findEducation("정기안전교육", item.educationHours).text }}
            </td>
     */
    교육_클래스(type, item) {
      const time = this.findEducation(type, item.educationHours).time;
      if (this.search.분기 === 0) {
        return time >= 12 ? 'circle green' : 'circle';
      } else {
        return time >= 2 ? 'circle green' : 'circle';
      }
    }
  },
};
</script>

<style lang="scss" scoped>
table.total {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;

  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 10px;
  }

  th,
  td:nth-child(1) {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
  }

  td {
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    text-align: center;
  }

  tr:last-child td:nth-child(n + 2) {
    background: #fff;
  }
}

table.list {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  background: white;

  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    background: #fafafa;
  }

  td {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    padding: 10px 4px;
  }
}

.circle:before {
  content: "";
  width: 10px;
  height: 10px;
  display: inline-block;
  margin-right: 8px;
  border-radius: 100%;
  background: #ea5455;
}

.green.circle:before {
  background: #28c76f;
}
.rotate-icon {
  animation: rotate 1s linear infinite;
}
</style>
